const cn = {
  common: {
    smartPhoneOrder: '手机点餐',
    seatNumber: '桌号',
    orderIsNowAvailableWithASmartphone: '现在使用智能手机订餐的服务也已经开通',
    readTheQrCodeAgainAfterClosingTheApp: '如果您退出了应用程序，请再次读取二维码',
    orderWithOtherSmartphones: '从另一部智能手机订餐',
    youCouldOrderWithOtherSmartphonesByReadingTheQrCodeShownOnThisPhone:
      '如果您用一台智能手机读取了显示的二维码，使用其他智能手机也可订餐',
    showTheQrCode: '显示二维码',
    youCouldOrderWithAMaximumOf6Smartphones: '最多可以使用6台智能手机订餐',
    close: '关闭',
    howToUse: '使用方法',
    doNotDisplayThisDialogAgain: '此后不再显示',
    todaysSpecialMenu: '今日推荐',
    cancel: '取消',
    numberBefore: '',
    numberAfter: '号',
    finishedDishes: '投入盘数',
    dishes: '盘',
    call: '服务铃',
    check: '结账',
    home: '主画面',
    search: '搜索',
    return: '返回',
    pleaseWaitTheEmployeeWillArriveShortly: '店员马上到来。\n请稍等片刻。请停留在此画面，谢谢',
    cancelTheCall: '取消呼叫',
    orderWithOtherCustomersSmartphone: '同桌就餐的顾客也可以通过智能手机订餐',
    order: '点餐',
    yes: '是',
    no: '否',
    end: '结束',
    putIn: '投入完毕',
    staffCalling: '呼叫店员',
    smartphoneOrderSuccess: '手机点餐结束',
    certification: '认证中',
    pleaseWait: '请稍候',
    busyTimes: '画面切换中，请耐心等待',
    scanTheQRCodeAgain: '如画面未切换，请再次扫描二维码',
    recommendMenu: '推荐一览',
    callStaff: '呼叫',
    cancelCall: '取消呼叫',
    yen: '日元',
    twGen: '元',
    cnGen: '元',
    dollar: '{price}美元',
    calorieUnit: 'kcal',
  },
  welcome: {
    smartPhoneOrderDescription: '扫描屏幕上的二维码，\n即可用手机点餐',
    availableShopList: '可使用手机点餐的店铺',
    operationMethod: '操作方法',
    alreadyInstalledApp: '已安装くら寿司APP的客户',
    alreadyInstalledAppDescription:
      '通过APP内的“手机点餐”按钮可以开启手机拍照功能，以读取手机上的QR CODE',
    notInstalledApp: '尚未安装くら寿司APP的客户',
    notInstalledAppDescription: '通过微信，扫描平板上的二维码',
  },
  preOrder: {
    'pre-orderConfirm': '确定下单内容',
    pleaseReadTheQrCodeAfterTheGuidance: '带位后，请扫描二维码',
    'thePre-orderingMenuIs10ForMaximum': '预订商品数量最多10个品项。',
    appointmentNumber: '预约号码',
    comfirming: '确认中',
    shop: '店',
    receptionNumber: '预约号码',
    reservationUsherTime: '预计带位时间',
    numberOfReservations: '预约人数',
    preOrder: '提前点餐',
    preOrderhowToUseDescription: '请按红色按键\n扫描二维码点餐',
    soldOutDescription: '目前商品缺货，无法点餐',
    preOrderLimitOver: '已超过预先点餐时限，\n入座后可以再次点餐',
  },
  sideMenu: {
    settings: '设置',
    menuAppearance: '菜单显示',
    menuLarge: '大',
    menuSmall: '小',
    languageSettings: '语言设置',
    showTheQrCodeAuthenticationForConnectingWithOtherSmartphones: '显示子机认证二维码',
    closeTheOrderScreenWithTheSmartphone: '关闭手机点餐画面',
    regardingSmartPhoneOrder: '关于手机点餐',
    showAllergenInformation: '显示过敏源信息',
  },
  orderHistory: {
    orderHistoryOfThisWholeTableWillBeDisplayed: '显示该餐桌的所有点餐历史记录。',
    orderHistory: '点餐记录',
    todaysOrderHistory: '今日的点餐历史记录',
    arrived: '已送达',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-prefix': '显示上次来店时的点餐历史记录',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-suffix': '件',
    orderFromSmartphone: '手机点餐内容',
    arriveComplete: '已读',
    orderPending: '线忙中',
    pastOrderHistory: '历史下单记录',
    pastOrderHistoryDescription: '*若31日内若历史记录超过100件，将显示最新下单的100件商品',
  },
  search: {
    searchCandidates: '你是不是想搜索',
    searchDescription: '输入关键字，相关商品会出现',
    searchResultBefore: '',
    searchResultAfter: '的搜索结果',
    listening: '语音读取中',
  },
  howToUse: {
    howToOrderWithTheSmartphone: '使用智能手机订餐的操作方法',
    canOrderWithSmartPhone: '可以使用手机点餐',
    sideMenuAlsoCanMakeBikkuraPon: '副餐也可以参与扭蛋游戏',
    canCompleteOrderBeforeMeal: '可提前在入座前完成点餐',
    preOrderAfterReserved:
      '完成订位后即可预先通过手机点餐\n入座后扫描平板上的二维码，点餐内容将会自动发送',
    noLimitForOrder: '同一桌可以使用手机点餐，没有人数限制',
    scanQrAndStart: '扫描平板上的二维码即可手机点餐',
  },
  order: {
    thankYouForYourOrder: '感谢您的点餐',
    theOrderHasBeenReceived: '点餐已确认',
    arrangeOfSpecialAndPopularMenu: '人气，推荐组合',
    cancelTheCheck: '取消结帐',
    orderCancelConfirmation: '要取消点餐吗?',
    pleaseWait: '请稍等',
    checkCancelDescription: '如需取消结账，\n请使用平板进行取消',
    endOrder: '结束手机点餐',
    askEndOrder: '结束手机点餐。还要继续吗?',
    endOrderConfirmation: '需要结束手机点餐吗?',
    endOrderAttention:
      '若无其他用户正在使用本点餐系统，今日的点餐历史记录及扭蛋记录将不保留，您仍要结束手机点餐吗?',
    endSession: '已中断，即将结束手机点餐',
  },
  bikkuraPon: {
    'bikkura-pon': '[bikkurapon]扭蛋游戏！',
    'bikkura-pon-jp': '[bikkurapon] 扭蛋游戏',
    smartPhoneOrderLimited: '手机点餐限定',
    bikkuraPonExplanationBefore: '使用手机下单含此标记的商品，每',
    bikkuraPonExplanationAfter: '即可玩一次扭蛋游戏(将于餐点送达后累计)',
    startBikkuraPon: '开始扭蛋游戏',
    howToStartBikkuraPon: '点此以开始扭蛋游戏',
    pressToStartBikkuraPon: '点此以开始扭蛋游戏',
    bikkuraPonConfirmation: '是否开始扭蛋游戏?',
    remainingTimes: '扭蛋游戏剩余 {count} 次',
    start: '开始',
    bikkuraPonUnabled: '无法进行扭蛋游戏',
    drawingFailure: '扭蛋游戏无法进行。\n请确认网络环境以及扭蛋游戏剩余次数后，\n重新操作',
    bikkuraPonInProgress: '扭蛋抽奖中',
    bikkuraPonInProgressDescription: '扭蛋抽奖中，\n请稍候再操作',
    congratulations: '中奖',
    lose: '未中奖',
  },
  present: {
    arrivedPresent: '恭喜您获得KURA寿司奖品',
    cannotCancelOperation: '※无法取消操作',
    notReceive: '不领取',
    receive: '领取',
  },
  textInImage: {
    waitingArea: '候位区',
    jackpot: '中奖',
    lose: '未中奖',
    numberPlate: '号码牌',
  },
  error: {
    oparateFromTouchPanel: '请使用桌席的平板重新操作',
    networkError: '连接失败',
    failedToProcess: '处理失败',
    notFound: '您搜索的页面不存在',
    notFoundOrRemoved: '您搜索的页面不存在，\n或已被更改',
    operatingAgainOnTopPage: '请您进入主画面「手机点餐」重整操作',
    backToTop: '返回主画面',
    limitErrorDescription: '非常抱歉，目前系统繁忙，请稍后再继续点餐',
    orderStopErrorDescription: '非常抱歉，目前系统繁忙，请稍后再继续点餐',
    stockoutErrorDescription: '此商品缺货中，请选择其他商品',
    orderError: '请稍后再次操作。\n若仍无法解决，请向店员寻求协助',
    unableToAuthenticate: '无法认证',
    failureToAuthorization: '认证失败',
    systemError: '系统错误',
    unknownError: '不明错误',
    unknownErrorDescription: '发生未知错误，程序停止',
    pleaseReload: '抱歉，请您重新加载',
    reload: '重新加载',
  },
  selfcheck: {
    comfirmNumbers: '人数确认',
    singleSeatCheckOut: '仅本桌进行结帐吗?',
    multiSeatsCheckOut: '若需要和其他桌合并结账，请选择“不是”店员将前来结账',
    dishesConfirm: '确认盘数',
    paymentConfirm: '确认金额',
    sushiPlate: '寿司盘',
    redPlate: '红盘',
    buckleSeparate: '扣环需拆下',
    putThePlateInThrowingSlot: '请将盘子放入投入口',
    accountingConfirmation: '请确认结帐内容',
    contents: '内容',
    quantity: '数量',
    totalAmount: '总计',
    checkConfirmed: '感谢您确认结账内容',
    takeNumberPlateToTheCounter: '请携带桌号牌至柜台结账',
    checking: '结帐中',
    waitUntilRedirect: '确认结帐内容后画面会自动切换',
    howToCancelSelfcheck: '若要取消结账，\n请使用平板或手机进行取消',
    checkOutContentHasBeenChanged: '结账内容有变更',
    pleaseCheckAgain: '请再次确认',
    closeCheckPageConfirmation: '是否结束结账?',
    abortCheckAndBackToMainConfirmation: '即将结束结账，返回主画面，\n仍要继续吗?',
    howToCancelCheckOut: '若要取消结账，请使用平板进行取消',
    smartphoneOrderFinished: '结束手机点餐',
    staffComingPleaseWait: '正在呼叫店员\n请稍候',
    error: '错误',
    failedToLoading: '读取失败',
    selfcheckTryAgainApology: '读取失败\n即将中断结账\n请返回主画面重新操作',
    backToMainMenu: '返回主画面',
    selfcheckRestartApology: '处理失败，返回主画面\n若画面没有自动切换，请使用平板点选返回按键操作',
    selfcheckWaitMomentApology:
      '结账失败\n请稍候再次操作\n若仍无法成功结账，请您呼叫店员协助操作，或使用平板进行操作',
    calling: '呼叫',
    confirming: '确认中',
    useTouchPanel: '请使用平板，点选返回按键操作',
  },
  pageTitle: {
    shopMenu: '主画面',
    order: '点餐',
    ad: '推荐名单',
    adOrder: '推荐名单',
    recommendOrder: '推荐一览',
    history: '点餐记录',
    historyOrder: '点餐记录',
    search: '搜索',
    searchOrder: '搜索',
  },
  siteId: '手机点餐|くら寿司',
}

export default cn
